import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AppBar, Box, Button, Stack, Toolbar } from '@mui/material'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { useRules } from 'hooks/useRules'
import { fetchChangePassword, fetchLogout, initialize, selectAuthentications } from 'slices/authenticationsSlice'
import { LoadingTypes } from 'slices/types'
import { ConfirmDialog } from 'components/dialog/ConfirmDialog'
import { CustomGrid } from 'components/grid/CustomGrid'
import { PasswordInput } from 'components/input/PasswordInput'

const ChangePassword = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { loading, error } = useAppSelector(selectAuthentications)

  const [password, setPassword] = useState('')
  const [passwordConfirmation, setPasswordConfirmation] = useState('')
  const [openConfirmDialog, setOpenConfrimDialog] = useState(false)
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false)

  const [validPassword, setValidPassword] = useState(false)
  const [validPasswordConfirmation, setValidPasswordConfirmation] = useState(false)

  const { rules } = useRules()

  const disabled = useMemo(
    () => !validPassword || !validPasswordConfirmation,
    [validPassword, validPasswordConfirmation]
  )

  const handleSubmit = () => {
    dispatch(fetchChangePassword({ password }))
  }
  const handleDialogClose = () => {
    setOpenConfrimDialog(false)
    setPassword('')
    setPasswordConfirmation('')
  }

  const handleLoguot = () => {
    dispatch(fetchLogout())
  }

  useEffect(() => {
    if (loading === LoadingTypes.Succeeded) {
      setOpenConfrimDialog(true)
    } else if (loading === LoadingTypes.Failed && error.includes('401')) {
      dispatch(initialize())
    } else {
      setOpenConfrimDialog(false)
    }
  }, [loading])

  return (
    <Box>
      <AppBar position="fixed" sx={{ zIndex: theme => theme.zIndex.drawer + 1, bgcolor: 'white' }}>
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}></Box>
          <Button onClick={() => setOpenLogoutDialog(true)}>{t('autentication.logout')}</Button>
        </Toolbar>
      </AppBar>
      <Box width="600px" px={2}>
        <CustomGrid label={t('autentication.password')}>
          <PasswordInput
            value={password}
            placeholder={t('autentication.password')}
            rules={[rules.password]}
            required
            errorMessage={password !== passwordConfirmation ? t('validate.samePassword') : undefined}
            setValid={setValidPassword}
            onChange={setPassword}
          />
        </CustomGrid>
        <CustomGrid label={t('autentication.passwordConfirmation')}>
          <PasswordInput
            value={passwordConfirmation}
            placeholder={t('autentication.passwordConfirmation')}
            rules={[rules.password]}
            required
            errorMessage={password !== passwordConfirmation ? t('validate.samePassword') : undefined}
            setValid={setValidPasswordConfirmation}
            onChange={setPasswordConfirmation}
          />
        </CustomGrid>
        <Stack direction="row" justifyContent="flex-end">
          <Button variant="contained" sx={{ width: '100px' }} disabled={disabled} onClick={handleSubmit}>
            {t('autentication.change')}
          </Button>
        </Stack>
        <ConfirmDialog open={openConfirmDialog} label={t('common.close')} onSubmit={handleDialogClose}>
          {t('message.succeeded')}
        </ConfirmDialog>
        <ConfirmDialog
          open={openLogoutDialog}
          label={t('autentication.logout')}
          onSubmit={handleLoguot}
          onCancel={() => setOpenLogoutDialog(false)}
        >
          {t('message.confirmLogout')}
        </ConfirmDialog>
      </Box>
    </Box>
  )
}

export default ChangePassword
